/* ==========================================================================
   MERELDON cart upsell — layers on top of "Complete the look" (cart-drawer.js)
   - Headline tied to the multi-buy tiers (2 items = 10% off, 3+ = 15% off).
   - Each card shows the price after the multi-buy discount it would unlock.
   - Complement map: no bags (none in the active range); same-category allowed.
   Keep tiers in sync with Admin > Discounts and snippets/mereldon-*-offer.
   ========================================================================== */
(function () {
  if (window.__mrlUpsell) return;
  window.__mrlUpsell = true;

  var TIERS = [
    { min: 3, rate: 0.15 },
    { min: 2, rate: 0.1 },
  ];

  function rateFor(qty) {
    for (var i = 0; i < TIERS.length; i++) if (qty >= TIERS[i].min) return TIERS[i].rate;
    return 0;
  }

  function bagCount(root) {
    var lines = root.querySelectorAll('.mrl-line[data-product-id]');
    var qty = 0;
    lines.forEach(function (line) {
      var input = line.querySelector('input[name="updates[]"], input.quantity__input, input[data-quantity-variant-id]');
      var n = input ? parseInt(input.value, 10) : NaN;
      qty += isNaN(n) ? 1 : n;
    });
    if (!lines.length) {
      var badge = document.querySelector('.cart-drawer__count-badge');
      qty = badge ? parseInt(badge.textContent, 10) || 0 : 0;
    }
    return qty;
  }

  function copy(qty) {
    if (qty <= 1) return { title: 'Add 1 more & save 10%', sub: 'Mix & match any style. Applied automatically.' };
    if (qty === 2) return { title: 'Add 1 more & save 15%', sub: '15% off every item when you have 3 or more.' };
    return { title: 'Complete the look', sub: '15% off every item in your bag is applied.' };
  }

  function withNumber(text, value) {
    var m = String(text).match(/\d[\d,]*(?:\.\d{1,2})?/);
    if (!m) return null;
    var formatted = value.toFixed(2);
    return text.replace(m[0], formatted);
  }

  function decorate(slot, root) {
    var section = slot.querySelector('.mrl-recs');
    if (!section) return;
    var qty = bagCount(root);
    var c = copy(qty);
    var title = section.querySelector('.mrl-recs__title');
    if (title) title.textContent = c.title;
    var sub = section.querySelector('.mrl-recs__sub');
    if (!sub && title) {
      sub = document.createElement('p');
      sub.className = 'mrl-recs__sub';
      section.querySelector('.mrl-recs__head').insertAdjacentElement('afterend', sub);
    }
    if (sub) sub.textContent = c.sub;

    var rate = rateFor(qty + 1);
    section.querySelectorAll('.mrl-rec').forEach(function (card) {
      var priceEl = card.querySelector('[data-mrl-rec-price] span');
      var deal = card.querySelector('.mrl-rec__deal');
      if (!priceEl || !rate) {
        if (deal) deal.remove();
        return;
      }
      var m = priceEl.textContent.replace(/,/g, '').match(/\d+(?:\.\d{1,2})?/);
      if (!m) return;
      var after = Math.round(parseFloat(m[0]) * (1 - rate) * 100) / 100;
      var label = withNumber(priceEl.textContent, after);
      if (!label) return;
      if (!deal) {
        deal = document.createElement('p');
        deal.className = 'mrl-rec__deal';
        card.querySelector('[data-mrl-rec-price]').insertAdjacentElement('afterend', deal);
      }
      deal.textContent = label + ' with multi-buy';
    });
  }

  function patch() {
    if (typeof MereldonCartRecommendations === 'undefined') return false;
    try {
      if (typeof MRL_COMPLEMENTS === 'object') {
        MRL_COMPLEMENTS.dress = ['dresses', 'matching-sets', 'tops'];
        MRL_COMPLEMENTS.set = ['matching-sets', 'dresses', 'tops'];
        MRL_COMPLEMENTS.jumpsuit = ['dresses', 'tops'];
        MRL_COMPLEMENTS.top = ['skirts', 'bottoms', 'tops'];
        MRL_COMPLEMENTS.bottom = ['tops', 'bottoms'];
        MRL_COMPLEMENTS.bag = ['dresses', 'tops'];
        MRL_COMPLEMENTS.other = ['dresses', 'tops'];
      }
      if (typeof MRL_COLLECTION_CATEGORY === 'object') {
        // Unmapped handles are never skipped, so same-category picks stay eligible.
        delete MRL_COLLECTION_CATEGORY.dresses;
        delete MRL_COLLECTION_CATEGORY.tops;
        delete MRL_COLLECTION_CATEGORY.bottoms;
        MRL_COLLECTION_CATEGORY['matching-sets'] = 'set';
      }
    } catch (e) {
      /* constants not reachable: keep theme defaults */
    }

    var proto = MereldonCartRecommendations.prototype;
    if (proto.__mrlPatched) return true;
    var originalPaint = proto.paint;
    proto.paint = function (slot, html) {
      originalPaint.call(this, slot, html);
      if (slot) decorate(slot, this.drawer || document);
    };
    proto.__mrlPatched = true;

    // Decorate anything already on screen.
    document.querySelectorAll('[data-cart-recommendations]').forEach(function (slot) {
      decorate(slot, slot.closest('cart-drawer') || document);
    });
    return true;
  }

  if (!patch()) {
    var tries = 0;
    var timer = setInterval(function () {
      if (patch() || ++tries > 40) clearInterval(timer);
    }, 150);
  }

  // Quantity changes re-render lines without repainting the slot: refresh the copy.
  document.addEventListener('change', function (event) {
    if (!event.target.closest || !event.target.closest('cart-drawer')) return;
    setTimeout(function () {
      document.querySelectorAll('[data-cart-recommendations]').forEach(function (slot) {
        decorate(slot, slot.closest('cart-drawer') || document);
      });
    }, 900);
  });
})();
